import React from "react";
import { Aside, ErrorMessage, ensure } from "sprint-common-web";

import { OrderRequestListingItem } from "../OrderRequestListingItem";

export type ListOrderRequestErrorDetailsProps = {
    item: OrderRequestListingItem;
    isOpen: boolean;
    onClose(): void;
};

export const ListOrderRequestErrorDetails: React.VFC<ListOrderRequestErrorDetailsProps> = ({
    item,
    isOpen,
    onClose
}: ListOrderRequestErrorDetailsProps) => {
    ensure(item.statusDetails, `Order Request ${item.id} misses "statusDetails"`);

    return (
        <Aside isOpen={isOpen} onDismiss={onClose} type="readonly" headerText="Status errors">
            {item.statusDetails.split("\n").map((msg, idx) => (
                <ErrorMessage text={msg} key={idx} />
            ))}
        </Aside>
    );
};
